import type { QueryClient } from '@tanstack/react-query';
import { nanoid } from 'nanoid';

import type { Schema } from '../../shared/schema';
import { schema } from '../../shared/schema';

const HOMEPAGE_DRAFT_QUERY_KEY = ['homepage', 'draft'] as const;

/**
 * Duplicated here to avoid cross-page imports.
 */
type HomepageDraftType = 'recommendations_draft' | 'ai_draft';

/**
 * Duplicated here to avoid cross-page imports.
 */
type HomepageDraftInput = {
	input: { issuePrompt: string };
	type: HomepageDraftType;
};

export function getDraftFromQueryClient(queryClient?: QueryClient): Schema | null {
	if (!queryClient) {
		return null;
	}

	const cachedDraft = queryClient.getQueryData<HomepageDraftInput>(HOMEPAGE_DRAFT_QUERY_KEY);
	if (!cachedDraft) return null;

	const id = nanoid();
	const convertedDraft: Schema = {
		id,
		...cachedDraft,
	};

	const result = schema.safeParse(schema.encode(convertedDraft));
	if (!result.success) {
		return null;
	}

	// Remove from cache after reading so subsequent navigation read from local storage
	queryClient.removeQueries({ queryKey: HOMEPAGE_DRAFT_QUERY_KEY });

	return result.data;
}
